import { render, staticRenderFns } from "./FormCargoLoss.vue?vue&type=template&id=63b0627a&scoped=true&"
import script from "./FormCargoLoss.vue?vue&type=script&lang=js&"
export * from "./FormCargoLoss.vue?vue&type=script&lang=js&"
import style0 from "./FormCargoLoss.vue?vue&type=style&index=0&id=63b0627a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0627a",
  null
  
)

export default component.exports